import { setupWorker, graphql, rest } from 'msw';

import { handlers } from '.';

declare global {
    interface Window {
        msw: {
            worker: import('msw').SetupWorkerApi;
            graphql: unknown;
            rest: unknown;
        };
    }
}

export const mockWorker = setupWorker(...handlers);

// Expose methods globally to make them available in e2e tests
window.msw = {
    worker: mockWorker,
    graphql,
    rest,
};
